"use client";
import { useOverlayState } from "@heroui/react";
import { SimpleModal } from "@/components/ui/modal";
import Link from "next/link";
import { useEffect, useRef } from "react";
import PrivacySettings from "./privacy-settings";
import { useConsent } from './use-consent';

export function ConsentBanner() {
  const { isOpen, open, setOpen } = useOverlayState();
  const { checkConsentRequired } = useConsent();

  const checkedRef = useRef(false);
  useEffect(() => {
    if (checkedRef.current) return;
    checkedRef.current = true;
    // Only show consent banner if ?consent=required is in the URL
    const params = new URLSearchParams(window.location.search);
    if (!params.has('consent', 'required')) return;
    if (checkConsentRequired()) {
      open();
    }
  }, [checkConsentRequired, open]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={handleClose}
      size="lg"
      scrollBehavior="inside"
      closeOnOverlayClick={false}
      footer={
        <p className="text-small">
          You can always change your consent preferences on the{" "}
          <Link href="/privacy">privacy policy page</Link>.
        </p>
      }
    >
      <PrivacySettings onClose={handleClose} />
    </SimpleModal>
  );
}
